module.exports = __webpack_public_path__ + "static/media/Melea Guilbault Headshot.01a274d6.jpeg";